import React from "react";
import "../../global/default.css";

interface HeaderProps {
  title: string;
  legend?: string;
  variant?: "default" | "compact" | "large";
  className?: string;
}

export const Header: React.FC<HeaderProps> = ({ title, legend, className }: HeaderProps) => {
  return (
    <header className={`header ${className ?? ""}`}>
      {legend && <p className="header-legend">{legend}</p>}
      <h3 className="header-title">{title}</h3>
    </header>
  );
};
